import React, { useState, useEffect, Fragment, useMemo, useRef } from "react";
import Select from "react-select";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import TokenCard from "../TokenEarning/TokenCard";
import loadImage from "blueimp-load-image";
import _, { debounce } from "lodash";

import GamificationImage from "../../assets/media/gamification.jpg";

import "./index.css";
import AddBrandTokenEarning from "./AddBrandTokenEarning";
import EditBrandTokenEarning from "./EditBrandTokenEarning";
import { ContentTypes, user_access } from "../../Constants/selections";
import { Grid } from "@material-ui/core";
import {
  GIF_UPLOAD,
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  YOUTUBE_URL,
} from "../../Constants/types";
import { getYoutubeId } from "../../Utils/utils";
import { coins } from "../../Utils/Constants";

const PercentCoin = require("../../assets/media/coins/percent-coin.png");

const TaskSelector = ({ number, options, hot_tasks, brand_name }) => {
  const [task, setTask] = useState({ value: false, label: "None" });
  useEffect(() => {
    loadHotTask(hot_tasks);
  }, [hot_tasks]);
  async function loadHotTask(hot_tasks) {
    let task_id = hot_tasks[number - 1];
    if (task_id) {
      let task = await Firebase.getEarningTaskById(task_id);
      setTask({ value: task, label: task.title });
    }
  }
  function handleChangeTask(newtask) {
    setTask(newtask);
    if (newtask.value) {
      Firebase.updateLiveTask(brand_name, number, newtask.value.id);
    } else {
      Firebase.updateLiveTask(brand_name, number, "");
    }
  }
  return (
    <div className="row-div mb-3">
      <p>{number === 1 ? "HOT" : number}</p>
      &nbsp;&nbsp;&nbsp;
      <div style={{ width: 300 }}>
        <Select
          value={task}
          onChange={handleChangeTask}
          options={options}
          isSearchable={true}
        />
      </div>
      &nbsp;&nbsp;&nbsp;
      {task.value && (
        <div className="logo-div">
          <div
            className="logo-img"
            style={{ backgroundImage: `url(${task.value.icon})` }}
          />
        </div>
      )}
    </div>
  );
};
const LiveTasks = ({
  all_tasks,
  hot_tasks,
  brand_name,
  lightUserUpgrade,
  updateLightUserUpgrade,
}) => {
  console.log("livetask:", all_tasks, hot_tasks);
  const options = all_tasks
    .filter((task) => !hot_tasks.includes(task.id))
    .map((task) => {
      return { value: task, label: task.title };
    });
  options.unshift({ value: false, label: "None" });
  return (
    <div className="row" style={{ marginTop: 50 }}>
      <div className="col-md-6 hot_tasks">
        {[...Array(5).keys()].map((element, index) => {
          return (
            <Fragment>
              <TaskSelector
                key={index}
                number={element + 1}
                options={options}
                hot_tasks={hot_tasks}
                brand_name={brand_name}
              />
              {index === 0 && (
                <div
                  className="row_item"
                  style={{ marginTop: "-20px", marginBottom: "10px" }}
                >
                  <input
                    type="checkbox"
                    checked={lightUserUpgrade}
                    onChange={() => updateLightUserUpgrade()}
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <p>Deactivate user upgrade as hot task for light user.</p>
                </div>
              )}
            </Fragment>
          );
        })}
      </div>
      <div className="col-md-6 hot_tasks">
        {[...Array(5).keys()].map((element, index) => {
          return (
            <TaskSelector
              key={index}
              number={element + 6}
              options={options}
              hot_tasks={hot_tasks}
              brand_name={brand_name}
            />
          );
        })}
      </div>
    </div>
  );
};

const type2Label = {
  article: "Article",
  survey: "Survey",
  task: "Gamified task",
};

const IncrementalTasks = ({
  tokenEarnings,
  hot_tasks,
  articles,
  surveys,
  brand_name,
  territory,
  user_type,
}) => {
  const [increTasks, setIncreTasks] = useState([]);
  const [brand_data, setBrandData] = useState({});
  const [loading, setLoading] = useState(-1);

  const uploadBtn = useRef(null);

  useEffect(() => {
    setLoading(-2);
    Firebase.getBrandDataByName(brand_name)
      .then((brand_data) => {
        setBrandData(brand_data);
        Firebase.getIncrementalTasks(brand_name)
          .then((res) => {
            const tempTasks = res
              .filter((item) => item.user_type === user_type)
              .sort((a, b) => a.order - b.order)
              .map(({ order, ...rest }) => rest);
            if (!tempTasks.length) tempTasks.push({});
            setIncreTasks(tempTasks);
            setLoading(-1);
          })
          .catch((e) => setLoading(-1));
      })
      .catch((e) => setLoading(-1));
  }, [user_type]);

  const options = useMemo(
    () => [
      { value: null, label: "None" },
      ...articles.map((article) => ({
        value: {
          type: "article",
          id: article.id,
          articleType: article.type,
          reward_value: article.reward_value || "0",
        },
        label: `${type2Label["article"]} - ${article.title}`,
      })),
      ...Object.entries(surveys).map(([id, survey]) => ({
        value: { type: "survey", id: id },
        label: `${type2Label["survey"]} - ${survey.name}`,
      })),
      ...tokenEarnings
        .sort((firstTask, secondTask) =>
          firstTask.title.localeCompare(secondTask.title)
        )
        .filter((task) => !hot_tasks.includes(task.id))
        .map((task) => {
          return {
            value: {
              type: "task",
              id: task.id,
              taskType: task.type,
              reward_value: task.reward_value || "0",
            },
            label: `${type2Label["task"]} - ${task.title}`,
          };
        }),
    ],
    [articles, hot_tasks, surveys, tokenEarnings]
  );

  const handleChangeTask = (number) => (option) => {
    const { value } = option;
    setIncreTasks((increTasks) => {
      const temp = [...increTasks];
      if (value) temp[number] = { ...temp[number], ...value };
      if (value === null) {
        if (temp[number])
          Firebase.removeIncrementalTasks(brand_name, user_type, number);
        temp.splice(number, 1);
        let items = temp.slice(number);
        items
          .filter((item) => item)
          .map(async (item, index) => {
            const { ...rest } = item;
            return await Firebase.updateIncrementalTask(
              brand_name,
              {
                ...rest,
                user_type,
                order: index + number,
              },
              index + number + 1
            );
          });
        if (!temp.length) temp.push({});
      } else {
        let order = temp[number] ? number : -1;
        const { ...rest } = temp[number];
        Firebase.updateIncrementalTask(
          brand_name,
          {
            order: number,
            user_type,
            ...rest,
          },
          order
        );
      }
      return temp;
    });
  };

  const handleChangeData = (number, field) => (value) => {
    if (!increTasks[number]) return;
    setIncreTasks((increTasks) => {
      const newTasks = [...increTasks];
      newTasks[number][field] = value;
      Firebase.updateIncrementalTask(
        brand_name,
        { ...newTasks[number], user_type, order: number },
        number
      );
      setLoading(-1);
      return newTasks;
    });
  };

  const handleAddTask = () => {
    if (increTasks.length < 12) setIncreTasks([...increTasks, {}]);
  };

  const handleUploadProgress = (snapshot) => {
    /*var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    const loading_script = UPLOADING_VIDEO + " " + progress + "%";
    this.setState({ loading_script });*/
  };

  const handleUploadError = (error) => {
    // this.setState({ loading: false, loading_script: "" });
  };

  const uploadContent = (number, contentType) => async (mediaContent) => {
    console.log("here:", number, contentType);
    const uploadFolder = "hot-topics/";
    const title = new Date().getTime().toString();
    if (contentType === GIF_UPLOAD) {
      setLoading(number);
      let gif_url = await Firebase.uploadGif(
        mediaContent,
        title,
        uploadFolder + "/gifs"
      );
      handleChangeData(number, "media_url")(gif_url);
    } else if (contentType === IMAGE_UPLOAD) {
      setLoading(number);
      console.log("here:", contentType);
      let img_url = await Firebase.uploadImage(
        mediaContent,
        title,
        uploadFolder + "/images"
      );
      console.log("here:", img_url);
      handleChangeData(number, "media_url")(img_url);
    } else if (contentType === VIDEO_UPLOAD) {
      const uploadTask = Firebase.uploadVideo(
        mediaContent,
        uploadFolder + "/videos"
      );
      setLoading(number);
      uploadTask.on(
        "state_changed",
        handleUploadProgress,
        handleUploadError,
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            handleChangeData(number, "media_url")(downloadURL);
          });
        }
      );
    } else if (contentType === YOUTUBE_URL) {
      setLoading(number);
      handleChangeData(number, "media_url")(mediaContent);
    } else {
      setLoading(-1);
    }
  };

  const onUploadMedia = (media_type, index) => () => {
    console.log("here:", media_type, index);
    if (!uploadBtn || !uploadBtn.current) return;
    handleChangeData(index, "media_type")(media_type);
    if (media_type === YOUTUBE_URL) return;
    uploadBtn.current.accept =
      media_type === GIF_UPLOAD
        ? "image/gif"
        : media_type === IMAGE_UPLOAD
        ? "image/jpeg, image/png"
        : "video/mp4";
    uploadBtn.current.addEventListener(
      "change",
      selectFile(index, media_type),
      { once: true }
    );
    uploadBtn.current.click();
  };

  const selectFile = (index, type) =>
    function (e) {
      if (e.target.files && e.target.files[0]) {
        var content = e.target.files[0];
        if (type === GIF_UPLOAD || type === VIDEO_UPLOAD) {
          uploadContent(index, type)(content);
        } else {
          const file_type = content.type;
          loadImage.parseMetaData(content, function (data) {
            var orientation = 0;
            if (data.exif) {
              orientation = data.exif.get("Orientation");
            }
            loadImage(
              content,
              function (canvas) {
                var base64data = canvas.toDataURL(file_type);
                var img_src = base64data.replace(
                  /^data\:image\/\w+\;base64\,/,
                  ""
                );
                uploadContent(index, type)(img_src);
                // let img_content = "data:" + type + ";base64," + img_src;
                // setImageViewable(img_content);
              },
              {
                canvas: true,
                orientation: orientation,
              }
            );
          });
        }
      }
    };

  const onYoutubeChange = (index) => (e) => {
    debounce(() => handleChangeData(index, "media_url")(e.target.value), 500);
  };

  return (
    <div className="incremental-tasks-container" style={{ marginTop: "50px" }}>
      <input
        ref={uploadBtn}
        type="file"
        id="image"
        name="image"
        className="form-control-file"
        style={{ display: "none" }}
      />
      {loading === -2 ? (
        <div className="loading">
          <i className="fa fa-4x fa-sync fa-spin text-muted" />
        </div>
      ) : (
        <div className="tasks-container">
          <div className="header-row">
            <Grid
              container
              // style={{ width: "100%", gap: "20px", flexWrap: "nowrap" }}
              spacing={3}
              alignItems="center"
            >
              <Grid xs={4} item>
                <div className="th-content">Task</div>
              </Grid>
              <Grid xs={2} item>
                <div className="th-content">Token Reward</div>
              </Grid>
              <Grid xs={2} item>
                <div className="th-content">Reward Value</div>
              </Grid>
              <Grid xs={4} item>
                <div className="th-content">Media</div>
              </Grid>
            </Grid>
            {increTasks.map((task, index) => (
              <Grid
                key={index}
                container
                // style={{ gap: "20px", flexWrap: "nowrap" }}
                spacing={3}
              >
                <Grid xs={4} item>
                  <div className="td-content">
                    <p>{index + 1}</p>
                    &nbsp;&nbsp;&nbsp;
                    <div style={{ width: "400px" }}>
                      <Select
                        value={
                          task.type
                            ? options.find(
                                (item) =>
                                  item.value &&
                                  item.value.type === task.type &&
                                  item.value.id === task.id
                              )
                            : options[0]
                        }
                        onChange={handleChangeTask(index)}
                        options={options}
                        isSearchable={true}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid xs={2} item>
                  <div className="td-content">
                    {task.type && (
                      <Fragment>
                        <div className="group-input">
                          <div>
                            <img
                              src={PercentCoin}
                              width="40px"
                              height="40px"
                              alt="coin"
                            />
                            <input
                              type="radio"
                              checked={task.is_premier !== true}
                              onClick={() =>
                                handleChangeData(index, "is_premier")(false)
                              }
                            />
                          </div>
                          <div>
                            <img
                              src={coins[territory || "UK"]}
                              width="40px"
                              height="40px"
                              alt="coin"
                            />
                            <input
                              type="radio"
                              checked={task.is_premier === true}
                              onClick={() =>
                                handleChangeData(index, "is_premier")(true)
                              }
                            />
                          </div>
                        </div>
                      </Fragment>
                    )}
                  </div>
                </Grid>
                <Grid xs={2} item>
                  <div className="td-content">
                    {task.type && (
                      <div className="profile-field">
                        <input
                          type="number"
                          className="form-control"
                          onChange={(e) =>
                            handleChangeData(
                              index,
                              "reward_value"
                            )(e.target.value)
                          }
                          value={task.reward_value || 0}
                          min="0"
                        />
                      </div>
                    )}
                  </div>
                </Grid>
                <Grid xs={4} item>
                  <div className="td-content">
                    {task.type && (
                      <div className="profile-field">
                        <div className="dropdown d-inline-block">
                          <button
                            type="button"
                            className={`btn btn-brand-hex`}
                            style={{
                              backgroundColor: "white",
                              color: "black",
                              "--hover-text-color": brand_data.white
                                ? "white"
                                : "black",
                              "--hover-color": brand_data.hex
                                ? brand_data.hex
                                : "black",
                            }}
                            id={`media-${task.user_type}-${index}-dropdown`}
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            {task.media_type ? "Edit" : "Add"}
                          </button>
                          <div
                            className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
                            aria-labelledby={`media-${task.user_type}-${index}-dropdown`}
                          >
                            <div className="media-type-container">
                              {ContentTypes.map((item, btnIndex) => (
                                <div
                                  key={btnIndex}
                                  className={`btn-media-type btn-brand-hex`}
                                  style={{
                                    backgroundColor: "white",
                                    color: "black",
                                    "--hover-text-color": brand_data.white
                                      ? "white"
                                      : "black",
                                    "--hover-color": brand_data.hex
                                      ? brand_data.hex
                                      : "black",
                                  }}
                                  onClick={onUploadMedia(item.value, index)}
                                >
                                  {item.label}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                        {loading === index && (
                          <div className="loading">
                            <i className="fa fa-4x fa-sync fa-spin text-muted" />
                          </div>
                        )}
                        {loading !== index &&
                          (task.media_type === YOUTUBE_URL ? (
                            <Fragment>
                              <input
                                className="youtube-input"
                                name="video"
                                defaultValue={task.media_url || ""}
                                placeholder={`Input youtube video url`}
                                onFinishChange={onYoutubeChange(index)}
                              ></input>
                              {task.media_url &&
                                task.media_url &&
                                getYoutubeId(task.media_url) && (
                                  <div className="image-preview">
                                    <iframe
                                      title="video"
                                      width="100%"
                                      height="100%"
                                      src={`//www.youtube.com/embed/${getYoutubeId(
                                        task.media_url
                                      )}?modestbranding=1&showinfo=0`}
                                      frameBorder="0"
                                      allowFullScreen
                                    ></iframe>
                                  </div>
                                )}
                            </Fragment>
                          ) : (
                            <div className="image-preview">
                              {task.media_type &&
                                task.media_url &&
                                (task.media_type === VIDEO_UPLOAD ? (
                                  <video
                                    alt={task.media_url}
                                    src={task.media_url}
                                    width="100%"
                                    height="100%"
                                  />
                                ) : (
                                  <img
                                    alt={task.media_url}
                                    src={task.media_url}
                                    width="100%"
                                    height="100%"
                                  />
                                ))}
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                </Grid>
              </Grid>
            ))}
          </div>
        </div>
      )}
      <div className="row-div mb-3 mt-4">
        <button
          className="btn btn-brand-hex btn-white"
          style={{
            backgroundColor: "white",
            color: "black",
            "--hover-text-color": brand_data.white ? "white" : "black",
            "--hover-color": brand_data.hex ? brand_data.hex : "black",
            margin: 10,
          }}
          onClick={handleAddTask}
        >
          Add a new token earning task
        </button>
      </div>
    </div>
  );
};

class BrandTokenEarning extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      brand: "",
      role: "",
      loading: true,
      tokenEarnings: [],
      hot_tasks: [],
      page: props.page || "all",
      brand_data: null,
      articles: [],
      user_type: user_access[0],
    };
  }

  componentDidMount() {
    if (!this.props.location.state) this.props.history.push("/");
    else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      Firebase.getBrandDataByID(brand, async (brand_data) => {
        if (!brand_data) return;
        this.setState({
          brand_data,
          brandID: brand,
          logo: brand_data.logo,
          icon: brand_data.icon,
          brand_name: brand_data.name,
          brand_url: brand_data.url,
          hex: brand_data.hex,
          is_property_brand: brand_data.is_property_brand
            ? brand_data.is_property_brand
            : false,
          territory: brand_data.territory || "UK",
          menus: brand_data.menus,
          lightUserUpgrade: brand_data.menus
            ? brand_data.menus.lightUserUpgrade === undefined
              ? true
              : brand_data.menus.lightUserUpgrade
            : true,
        });

        Firebase.getAllTokenEarnings((tokenEarnings) => {
          let super_tokenEarnings = tokenEarnings
            .filter((obj) => !obj.brand)
            .map((tokenEarning) => ({ ...tokenEarning, type: "super" }));
          let brand_tokenEarnings = tokenEarnings
            .filter((obj) =>
              obj.brand
                ? obj.brand.toLowerCase() === brand_data.name.toLowerCase()
                : false
            )
            .map((tokenEarning) => ({ ...tokenEarning, type: "brand" }));
          let total_tokenEarnings =
            super_tokenEarnings.concat(brand_tokenEarnings);
          console.log("tokenEarnings:", total_tokenEarnings);
          this.setState({ tokenEarnings: total_tokenEarnings, loading: false });
        });
        Firebase.getAllHotTasks(brand_data.name, (hot_tasks) => {
          console.log("hot_tasks:", hot_tasks);
          this.setState({ hot_tasks });
        });

        const { parent } = brand_data;
        Firebase.getArticlesByBrand(brand_data.name, (brand_articles) => {
          Firebase.getArticlesByBrand("Ecosystem", (super_articles) => {
            const articles = [
              ...brand_articles.map((ba) => ({ ...ba, type: "brand" })),
              ...super_articles.map((sa) => ({ ...sa, type: "super" })),
            ];
            const clone_articles = _.cloneDeep(articles);
            if (parent) {
              // I am inside sub brand and wanna get parent articles
              Firebase.getBrandDataByID(parent, (parentBrand_Data) => {
                const parentBrandName = parentBrand_Data.name;
                Firebase.getArticlesByBrand(parentBrandName, (res) => {
                  const parentArticles = res.filter((a) => a.postToSub);
                  this.setState({
                    articles: [...clone_articles, ...parentArticles].sort(
                      (a, b) => a.time - b.time
                    ),
                  });
                });
              });
            } else {
              if (role === "isUmbrella" && brand_data.umbrella) {
                const articles = clone_articles.filter(
                  (item) => item.postToSub
                );
                this.setState({
                  articles: articles.sort((a, b) => a.time - b.time),
                });
              } else
                this.setState({
                  articles: clone_articles.sort((a, b) => a.time - b.time),
                });
            }
          });
        });
      });
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.page !== this.props.page) {
      this.setState({ page: this.props.page });
    }
  }

  onAddPendingTask = (tokenEarning) => {
    const payload = {
      brand: this.state.brand_name,
      ...tokenEarning,
      pending: true,
    };
    let { tokenEarnings } = this.state;
    tokenEarnings.push(payload);
    this.setState({ tokenEarnings });
    Firebase.addTokenEarning(payload);
  };

  onItemClicked = (selectedTokenEarning) => {
    this.setState({
      selectedTokenEarning,
      icon: selectedTokenEarning.icon,
    });
  };
  togglePage = (page) => {
    this.setState({ page });
  };

  toggleTab = (user_type) => {
    this.setState({ user_type });
  };

  updateLightUserUpgrade = async () => {
    const { brandID, menus, lightUserUpgrade } = this.state;
    await Firebase.updateBrandDataById(brandID, {
      menus: { ...menus, lightUserUpgrade: !lightUserUpgrade },
    });
    this.setState({ lightUserUpgrade: !lightUserUpgrade });
  };

  onIncrementalTasksChange = async (increTasks) => {
    const { brandID, menus, lightUserUpgrade } = this.state;
  };

  renderContent = () => {
    const {
      tokenEarnings,
      page,
      hot_tasks,
      loading,
      brand_name,
      lightUserUpgrade,
      articles,
      brand_data,
      user_type,
    } = this.state;
    const { surveys = [], territory, hex, white } = brand_data;

    return (
      <div className="token-earning-content">
        {/* <div className="switch-div">
          <button
            className={`btn ${page === "all" ? "btn-yellow" : "btn-white"}`}
            onClick={() => this.togglePage("all")}
          >
            All gamification tasks
          </button>
          <button
            className={`btn ${page === "hot" ? "btn-yellow" : "btn-white"}`}
            onClick={() => this.togglePage("hot")}
          >
            Live gamification tasks
          </button>
          <button
            className={`btn ${
              page === "incremental-task" ? "btn-yellow" : "btn-white"
            }`}
            onClick={() => this.togglePage("incremental-task")}
          >
            Incremental tasks
          </button>
        </div> */}
        {page === "all" && (
          <div className="token-earning-items">
            <img
              src={GamificationImage}
              alt="gamification"
              className="gamification-img"
            />
            {tokenEarnings.map((item, index) => (
              <TokenCard
                item={item}
                onItemClicked={() => this.onItemClicked(item)}
              />
            ))}

            <button
              className="btn btn-brand-hex btn-white"
              style={{
                backgroundColor: "white",
                color: "black",
                "--hover-text-color": brand_data.white ? "white" : "black",
                "--hover-color": brand_data.hex ? brand_data.hex : "black",
                margin: 10,
              }}
              data-toggle="modal"
              data-target="#brand_token_earning_modal"
            >
              Add a new token earning task
            </button>
          </div>
        )}
        {page === "hot" && (
          <div>
            <LiveTasks
              all_tasks={tokenEarnings}
              hot_tasks={hot_tasks}
              brand_name={brand_name}
              style={{ marginTop: 50 }}
              lightUserUpgrade={lightUserUpgrade}
              updateLightUserUpgrade={this.updateLightUserUpgrade}
            />
            {/* <div className="row_item">
              <input
                type="checkbox"
                checked={lightUserUpgrade}
                onChange={() => this.updateLightUserUpgrade()}
              />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <p>Disable light user upgrade as Hot Task</p>
            </div> */}
          </div>
        )}
        {page === "incremental-task" && (
          <div className="incremental-task-container">
            <div className="incremental-task-tab">
              {user_access.map(({ value, label }, i) => (
                <button
                  className={`btn`}
                  key={i}
                  style={{
                    backgroundColor: user_type.label === label ? hex : "white",
                    color:
                      user_type.label === label
                        ? white
                          ? "white"
                          : "black"
                        : "black",
                  }}
                  onClick={() => this.toggleTab({ label: label, value: value })}
                >
                  {label.replace(/brandname/i, brand_name)}
                </button>
              ))}
            </div>
            {loading ? (
              <div className="loading">
                <i className="fa fa-4x fa-sync fa-spin text-muted" />
              </div>
            ) : (
              <IncrementalTasks
                tokenEarnings={tokenEarnings}
                hot_tasks={hot_tasks}
                articles={articles}
                territory={territory}
                surveys={surveys}
                user_type={user_type.value}
                brand_name={brand_data.name}
              />
            )}
          </div>
        )}
      </div>
    );
  };
  onEdit = (payload) => {
    const { id } = this.state.selectedTokenEarning;
    payload.pending = true;
    Firebase.editTokenEarning(id, payload);
  };
  render() {
    const {
      username,
      role,
      loading,
      logo,
      brand,
      brand_name,
      is_property_brand,
      territory,
      icon,
      selectedTokenEarning,
    } = this.state;

    return (
      <div id="page-container" className="token-earning-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container">
          {loading && (
            <div className="loading">
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            </div>
          )}
          {!loading && this.renderContent()}

          <AddBrandTokenEarning
            onAdd={this.onAddPendingTask}
            territory={territory}
          />
          <EditBrandTokenEarning
            {...selectedTokenEarning}
            territory={territory}
            icon={icon}
            onSave={this.onEdit}
          />
        </main>
      </div>
    );
  }
}

export default BrandTokenEarning;



// WEBPACK FOOTER //
// ./src/screens/BrandTokenEarning/index.js